@if (showNewChatButton()) {
   <div class="d-flex justify-content-between w-full">
        <div></div>

        <!-- Move to New chat screen -->
        <button class="btn btn-transparent-rounded" (click)="openNewChat.emit()">
            <svg name="icon-add" ycnIcon>
            </svg>
            <span class="text-smallest">New Chat</span>
        </button>
    </div>
}

<div class="form-control-colors relative">
    <!-- Drag-and-drop cue: shown only while files are dragged over the chat bar -->
    @if (isDragOver()) {
        <div class="agent-drop-overlay absolute top-0 left-0 right-0 bottom-0 d-flex align-items-center justify-content-center text-small">
            <svg name="icon-attach" ycnIcon></svg>&nbsp;Drop files to attach
        </div>
    }

    <!-- Files added -->
    @if (uploadedFiles().length > 0) {
        <div class="section-ai-input-files" [class.section-ai-input-files-narrow]="compactLayout()">
            <div>
                <div class="d-flex flex-wrap pt-10">
                    @for (file of uploadedFiles(); track $index) {
                        <div class="plate-container">
                            <div class="plate plate-thin plate-noshadow plate-white">
                                <div class="plate-header width-full">
                                    <div class="plate-title min-width-0">
                                        <div class="plate-title-icon">
                                            <svg [name]="getFileIcon(file.name, file.type)" ycnIcon>
                                            </svg>
                                        </div>
                                        <div class="plate-title-name min-width-0 text-ellipsis">
                                            {{ file.name }}
                                        </div>
                                    </div>
                                    <div class="plate-controls">
                                        <button class="btn btn-xs btn-circle btn-transparent btn-lightgray plate-control btn-close"
                                                (click)="removeFile($index)">
                                            <svg name="icon-close" ycnIcon>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    }

    <div class="d-flex justify-content-between align-items-center flex-wrap">
        @if (smartCompareOnly()) {
            <div class="form-control-autosize relative flex-auto cursor-pointer"
                 data-test-id="agent-smart-compare-only-input"
                 (click)="openUpsell()">
                <textarea class="field-input border-0" placeholder="Ask Y..." rows="1" readonly
                          ycnDisabled [disabled]="true"></textarea>
            </div>
            <div class="d-flex align-items-center ml-auto pt-1 pr-2 pb-1 height-40">
                <button class="btn btn-outline btn-secondary btn-sm"
                        data-test-id="agent-smart-compare-only-button"
                        (click)="openSmartCompareModal()">
                    <svg name="icon-compare-ai" ycnIcon></svg>
                    <span class="ml-1">Smart Compare</span>
                </button>
            </div>
        } @else if (isTranscribing()) {
            <ycn-audio-transcription-input
                #audioInput
                class="flex-auto"
                [placeholder]="'Ask Y...'"
                [inputText]="textFormControl.value ?? ''"
                [maxCanvasWidth]="maxAudioCanvasWidth()"
                (transcribedText)="onTranscribedText($event)"
                (transcriptionCancel)="onTranscriptionCancel()"
            ></ycn-audio-transcription-input>
        } @else {
            <div class="form-control-autosize max-rows-5 relative flex-auto"
                 [class.width-full]="hasNewline()"
                 [attr.data-replicated-value]="textFormControl.value">
                    <textarea #textInput class="field-input border-0 ng-pristine ng-untouched ng-valid ng-empty"
                              placeholder="Ask Y..." rows="1" [formControl]="textFormControl"
                              (keydown.enter)="onEnter($any($event))"
                    ></textarea>
            </div>
            <div class="d-flex align-items-end ml-auto pt-1 pr-2 pb-1"
                 [class.width-full]="compactLayout()"
                 [class.pl-2]="compactLayout()">
                <div class="d-flex align-items-center justify-content-between"
                     [class.width-full]="compactLayout()"
                     [class.height-40]="!compactLayout()">
                    <div class="d-flex align-items-center mr-1">
                    @if (!compactLayout()) {
                        <ng-container [ngTemplateOutlet]="modelSelector"/>
                    }
                    @if (compactLayout()) {
                        @if (!fileUploadDisabled()) {
                            <button class="btn btn-24 btn-circle btn-transparent2 btn-lightgray mr-1"
                                    (click)="agentFileInput.click()"
                                    ycnTooltip [tooltipTitle]="'Attach Files'"
                                    [tooltipPlacement]="'top'"
                                    [tooltipIgnoreViewport]="true">
                                <svg name="icon-attach" ycnIcon></svg>
                            </button>
                        }
                    } @else {
                        <div class="dropdown mr-1" [class.show]="isDropdownOpen()"
                             [ycnAutoDropDirection]="true">
                            <button class="btn btn-24 btn-circle btn-transparent2 btn-lightgray dropdown-toggle"
                                    [class.active]="isDropdownOpen()"
                                    (click)="toggleDropdown()"
                                    role="button" aria-haspopup="true"
                                    [attr.aria-expanded]="isDropdownOpen()">
                                <svg name="icon-add-circle" ycnIcon>
                                </svg>
                            </button>
                            <div #dropdownMenu class="dropdown-menu dropdown-menu-with-icons"
                                 [class.show]="isDropdownOpen()">
                                @if (!fileUploadDisabled()) {
                                    <a class="dropdown-item" href="javascript:void(0)"
                                       (click)="agentFileInput.click(); isDropdownOpen.set(false)">
                                        <svg name="icon-attach" ycnIcon></svg>
                                        <div class="dropdown-item-text">Attach Files</div>
                                    </a>
                                    <div class="dropdown-divider"></div>
                                }
                                @if (hasSmartCompareFeature) {
                                    <div class="dropdown dropdown-nested">
                                        <div class="dropdown-item dropdown-toggle">
                                            <svg name="icon-compare-ai" ycnIcon></svg>
                                            <div class="dropdown-item-text">Smart Flows</div>
                                        </div>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a class="dropdown-item" href="javascript:void(0)"
                                               (click)="openSmartCompareModal()">
                                                <svg name="icon-compare-ai" ycnIcon></svg>
                                                <div class="dropdown-item-text">Smart Compare</div>
                                            </a>
                                        </div>
                                    </div>
                                }
                                <a class="dropdown-item" href="javascript:void(0)"
                                   (click)="openSavedPrompts.emit(); isDropdownOpen.set(false)">
                                    <svg name="icon-list-checked" ycnIcon></svg>
                                    <div class="dropdown-item-text">Prompt Library</div>
                                </a>
                            </div>
                        </div>
                    }
                    <button class="btn btn-24 btn-circle btn-transparent2 btn-lightgray"
                            (click)="startTranscription()"
                            ycnTooltip [tooltipTitle]="'Dictation'"
                            [tooltipPlacement]="'top'"
                            [tooltipIgnoreViewport]="true">
                        <svg name="icon-microphone" ycnIcon></svg>
                    </button>
                    </div>
                    <div class="d-flex align-items-center">
                    @if (compactLayout()) {
                        <ng-container [ngTemplateOutlet]="modelSelector"/>
                    }
                    <span class="d-inline-block"
                          ycnTooltip
                          [tooltipTitle]="submitButtonTooltip()"
                          [tooltipPlacement]="'top'"
                          [tooltipIgnoreViewport]="true">
                        <button class="btn btn-32 btn-circle btn-ai-prompt"
                                [disabled]="isInputDisabled()"
                                (click)="submit()">
                            <svg name="icon-update" ycnIcon></svg>
                        </button>
                    </span>
                    </div>
                </div>
            </div>
        }
    </div>
</div>

<!-- AI disclaimer -->
<div class="text-smallest text-center text-gray-30 mt-1">
    AI can make mistakes. Please double-check responses.
</div>

<ng-template #modelSelector>
    @if (modelOptions().length > 0) {
        <ycn-single-select-dropdown class="mr-1"
                                    data-test-id="agent-model-selector"
                                    [ycnAutoDropDirection]="true"
                                    ycnTooltip [tooltipTitle]="modelTooltip()"
                                    [tooltipPlacement]="'top'"
                                    [tooltipIgnoreViewport]="true"
                                    [config]="modelDropdownConfig()"
                                    [selectedValue]="selectedModelId() ?? ''"
                                    [placeholderText]="'Default'"
                                    [inputDisabled]="modelLocked()"
                                    [isInHeader]="true"
                                    [customCssClasses]="{ button: 'btn btn-xs btn-transparent2 btn-lightgray text-smallest text-normal text-normal-case text-ellipsis max-width-100', dropdownMenu: 'dropdown-menu-right' }"
                                    (changeHandler)="modelChange.emit($event)"/>
    }
</ng-template>

<input type="file" #agentFileInput (change)="onFileChange($event)" multiple hidden/>

<ycn-agent-smart-compare-modal
    #smartCompareModal
    (submitCompare)="onSmartCompareSubmit($event)">
</ycn-agent-smart-compare-modal>
